'use client';

import { Box, Hidden } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { useLocale } from 'next-intl';
import { StatsBox } from './stats-box/stats-box';
import css from './stats-section.module.css';
function StatsSection() {
  return <Box className={css.stats} data-sentry-element="Box" data-sentry-component="StatsSection" data-sentry-source-file="stats-section.tsx">
            <Hidden below="xlg" data-sentry-element="Hidden" data-sentry-source-file="stats-section.tsx">
                <Box className={css.carousel} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                    <Box className={css.scroller} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                    </Box>
                </Box>
            </Hidden>

            <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="stats-section.tsx">
                <Box className={css.carousel} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                    <Box className={css.scroller} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                        <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                    </Box>
                </Box>
            </Hidden>

            <Hidden below="md" above="xlg" data-sentry-element="Hidden" data-sentry-source-file="stats-section.tsx">
                <Box className={css.static} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                    <StatBoxes data-sentry-element="StatBoxes" data-sentry-source-file="stats-section.tsx" />
                </Box>
            </Hidden>
        </Box>;
}
function StatBoxes() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  return <>
            <StatsBox title={t('statsBox1.titleCount', {
      count: 30
    })} // million app downloads
    desc={t(`statsBox1.desc`)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/stats/stat-box-1.png`} width={246} height={242} data-sentry-element="StatsBox" data-sentry-source-file="stats-section.tsx" />
            <StatsBox title={t('statsBox2.titleCount', {
      count: 2
    })} // billion tasks completed
    desc={t(`statsBox2.desc`)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/stats/stat-box-2.png`} width={242} height={275} data-sentry-element="StatsBox" data-sentry-source-file="stats-section.tsx" />
            <StatsBox title={t('statsBox3.titleCount', {
      count: 160
    })} // countries
    desc={t(`statsBox3.desc`)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/stats/stat-box-3.png`} width={280} height={205} data-sentry-element="StatsBox" data-sentry-source-file="stats-section.tsx" />
            <StatsBox title={t('statsBox4.titleCount', {
      count: 1
    })} // million Pro users
    desc={t(`statsBox4.desc`)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/stats/stat-box-4.png`} width={274} height={275} data-sentry-element="StatsBox" data-sentry-source-file="stats-section.tsx" />
        </>;
}
export { StatsSection };